module.exports = __FOREMAN_VENDOR__PATTERNFLY_REACT_TOKENS__;